import * as React from "react";
import { forwardRef } from "react";
const SvgPlay = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" ref={ref} {...props}><path fill="currentColor" d="M2 16.427V3.664a1 1 0 0 1 1.47-.884l12.762 6.781a1 1 0 0 1-.044 1.789L3.424 17.332A1 1 0 0 1 2 16.427Z" /></svg>;
const ForwardRef = forwardRef(SvgPlay);
export default ForwardRef;